import { Modifier } from './Modifier';
export class TwistModifier extends Modifier {
    constructor(disabled, parameters) {
        super('twist', disabled, parameters, false);
    }
    apply(geometry) {
        if (this.disabled)
            return;
        const positions = geometry.attributes.position.array;
        const { angle } = this.parameters;
        const maxHeight = Math.max(...Array.from(positions).filter((_, i) => i % 3 === 1));
        for (let i = 0; i < positions.length; i += 3) {
            const x = positions[i];
            const y = positions[i + 1];
            const z = positions[i + 2];
            // Calculate twist angle based on height
            const heightRatio = y / maxHeight;
            const twistAngle = (angle * Math.PI / 180) * heightRatio;
            // Apply rotation around Y axis
            const cos = Math.cos(twistAngle);
            const sin = Math.sin(twistAngle);
            positions[i] = x * cos - z * sin;
            positions[i + 2] = x * sin + z * cos;
        }
        geometry.attributes.position.needsUpdate = true;
        geometry.computeVertexNormals();
    }
}
